export default "__VITE_ASSET__4b0b95a5__"